import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'

import EpisodesBlock from '@/app/components/listing/EpisodesBlock.vue'
import NoCurrentlyReadingDocsBlock from '@/app/components/listing/NoCurrentlyReadingDocsBlock.vue'
import NoFinishedDocsBlock from '@/app/components/listing/NoFinishedDocsBlock.vue'
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

import { filteredDocsByDocType } from '@/models/doc'

import { useWait } from '@/app/composables/useWait'
import type { Doc, DocsUserDataResponse } from '@/models/interfaces'
import LibraryLayout from '@/app/components/library/LibraryLayout.vue'
import { PodcastEpisodesView } from '@/models/docs.list.podcasts.episodes'
import { DocSortOption, DocsViewMediator } from '@/models/doc'
import { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'LibraryEpisodes',
  props: {
    docs: {},
    docsUserData: {}
  },
  setup(__props: any) {

const props = __props

const wait = useWait()

const currentlyReadingViewRef = ref<Raw<ListView> | null>(null)
const finishedViewRef = ref<Raw<ListView> | null>(null)
const favoritesViewRef = ref<Raw<ListView> | null>(null)

onBeforeMount(async () => {
  await getBooks()
})

const getBooks = async (): Promise<void> => {
  wait.start('Loading Library')
  try {
    /* TODO: We need to implement offline support for home/docs, #12899.

    if (offline.isOffline) {
       await loadBookListFromNativeStorage()
     } */

    const episodesData = filteredDocsByDocType(props.docs, 'podcast_episode')

    const reading = await PodcastEpisodesView.createView(
      episodesData,
      props.docsUserData,
    )
    reading.enableContinueReading()
    reading.enableActionsButton()
    await reading.setList('reading')
    await reading.sort(DocSortOption.accessed)
    currentlyReadingViewRef.value = new ListView('Reading Now', reading, {
      viewAllLink: '/app/podcasts/episodes/list/reading',
    })

    const finished = await PodcastEpisodesView.createView(
      episodesData,
      props.docsUserData,
    )
    finished.enableActionsButton()
    await finished.setList('finished')
    await finished.sort(DocSortOption.accessed)
    finishedViewRef.value = new ListView('Finished', finished, {
      viewAllLink: '/app/podcasts/episodes/list/finished',
    })

    const favorites = await PodcastEpisodesView.createView(
      episodesData,
      props.docsUserData,
    )
    favorites.enableActionsButton()
    await favorites.setIsFavorite(true)
    await favorites.sort(DocSortOption.accessed)
    favoritesViewRef.value = new ListView('Favorites', favorites, {
      viewAllLink: '/app/podcasts/episodes/list/favorites',
    })

    // The list of episode-list views on this page. They all share the same
    // episodesData.
    // We create this but we don't need to store it anywhere; the views
    // hold references to it.
    new DocsViewMediator([reading, finished, favorites])

    wait.end('Loading Library')
  } catch (error) {
    if (Sentry) {
      Sentry.captureException(error)
    }
    wait.end('Loading Library')
    wait.start('Error Loading Library')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LibraryLayout, null, {
    default: _withCtx(() => [
      (currentlyReadingViewRef.value && currentlyReadingViewRef.value.dataLength)
        ? (_openBlock(), _createBlock(EpisodesBlock, {
            key: 0,
            view: currentlyReadingViewRef.value
          }, null, 8, ["view"]))
        : (_openBlock(), _createBlock(NoCurrentlyReadingDocsBlock, {
            key: 1,
            title: "Reading now"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("p", null, " Podcast episodes you're currently reading will appear here. Find new things to read on the Discover page! ", -1)
            ]))]),
            _: 1
          })),
      (favoritesViewRef.value && favoritesViewRef.value.dataLength)
        ? (_openBlock(), _createBlock(EpisodesBlock, {
            key: 2,
            view: favoritesViewRef.value
          }, null, 8, ["view"]))
        : (_openBlock(), _createBlock(EmptyListingBlock, {
            key: 3,
            title: "Favorites",
            class: "empty-favorite"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", null, [
                _createElementVNode("p", null, "Podcast episodes you've marked as a Favorite will appear here."),
                _createElementVNode("p", null, " To mark an episode as a Favorite, click the bookmark icon on the podcast card or while reading the podcast. ")
              ], -1)
            ]))]),
            _: 1
          })),
      (finishedViewRef.value && finishedViewRef.value.dataLength)
        ? (_openBlock(), _createBlock(EpisodesBlock, {
            key: 4,
            view: finishedViewRef.value
          }, null, 8, ["view"]))
        : (_openBlock(), _createBlock(NoFinishedDocsBlock, { key: 5 }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("p", null, "Podcast episodes you've finished will appear here.", -1),
              _createElementVNode("p", null, " To mark a podcast episode as Finished, click the three dot menu on the episode card, then click \"Move to Finished\". ", -1)
            ]))]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})